export const uppercaseCustomerNameInput = (value) =>
  String(value || '')
    .replace(/\s+/gu, ' ')
    .trimStart()
    .toLocaleUpperCase('es-CO');

export const normalizeCustomerName = (value) =>
  uppercaseCustomerNameInput(value).trim();
